import React, { useState } from "react"
import { Link } from "react-router-dom"
import { Button, Input } from "reactstrap"
import { formatAddress } from "../utils"
import { useContracts } from "../libs/useMetaMaskWallet"
import EthereumIcon from "../assets/images/crypto/icons/ethereum.webp"
import AvalancheIcon from "../assets/images/crypto/icons/avalanche.webp"
import MaticIcon from "../assets/images/crypto/icons/matic.webp"
import BinanceIcon from "../assets/images/crypto/icons/binance.png"

const TradingCard = (props) => {
    const contracts = useContracts()

    const { data, isConnectedToWallet, connectWallet } = props
    const [loading, setLoading] = useState(false)
    const [showMenu, setShowMenu] = useState(false)
    const [sellInput, showSellInput] = useState(false)
    const [price, setPrice] = useState("")
    const tradingApi = "https://nft.idexo.io"

    const sellToken = async () => {
        if (data.source.includes("avalanche")) {
            const res = await contracts.tradeAvalanche.openForSale(data.token_id, Number(price))
            if (res.status) {
                sellTokenApi(price)
            }
        } else if (data.source.includes("polygon")) {
            const res = await contracts.tradePolygon.openForSale(data.token_id, Number(price))
            if (res.status) {
                sellTokenApi(price)
            }
        }
    }

    const buyToken = async () => {
        setShowMenu(!showMenu)
        if (data.source.includes("avalanche")) {
            const res = await contracts.tradeAvalanche.bid(data.token_id)
            console.log(res)
        } else if (data.source.includes("polygon")) {
            const res = await contracts.tradePolygon.bid(data.token_id)
            console.log(res)
        }
        setShowMenu(!showMenu)
    }

    const closeForSaleToken = async () => {
        setShowMenu(!showMenu)
        if (data.source.includes("avalanche")) {
            const res = await contracts.tradeAvalanche.closeForSale(data.token_id)
            if (res.status) {
                sellTokenApi("-1")
            }
        } else if (data.source.includes("polygon")) {
            const res = await contracts.tradePolygon.closeForSale(data.token_id)
            if (res.status) {
                sellTokenApi("-1")
            }
        }
    }

    const sellTokenApi = (price) => {
        fetch(tradingApi, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                token: localStorage.jwtToken
            },
            body: JSON.stringify({
                source: data.source,
                inserted: data.inserted,
                price
            })
        })
            .then(() => {
                setLoading()
                setShowMenu(!showMenu)
            })
            .catch((error) => {
                console.log(error)
            })
    }

    const changeSellTokenInput = () => {
        setShowMenu(!showMenu)
        showSellInput(!sellInput)
    }

    const networkIcon = {
        ethereum: EthereumIcon,
        binance: BinanceIcon,
        polygon: MaticIcon,
        avalanche: AvalancheIcon
    }

    console.log(data)

    return (
        <React.Fragment>
            <div className="trading-card">
                <div className={showMenu ? "card-item fixed" : "card-item"}>
                    <div className="card-img">
                        <img src={data.details.uri} alt={"card"} className="w-100" />
                        {data.price && (
                            <div className="card-price">
                                <label>Price</label>
                                <h4>{data.price}</h4>
                            </div>
                        )}
                    </div>
                    <div className="blockchain-icon">
                        <img src={networkIcon[data.blockChain]} alt="" />
                    </div>
                    <div className="card-content">
                        <h2>{data.details.name}</h2>
                        <p>{data.details.description}</p>
                    </div>
                    <div className="card-hovered-content">
                        <div className="user-details">
                            <h2>{data.details.name}</h2>
                            <p>
                                <strong>{formatAddress(data.wallet)}</strong>
                                <span>{data.author}</span>
                            </p>
                        </div>
                        <div className="card-buttons">
                            {isConnectedToWallet ? (
                                <>
                                    {sellInput ? (
                                        <>
                                            <Input placeholder="Price" value={price} onChange={(e) => setPrice(e.target.value)} />
                                            <div className="sell-input my-2" style={{ display: "flex" }}>
                                                <Button color="primary" onClick={sellToken}>
                                                    Confirm
                                                </Button>
                                                <Button color="secondary" outline onClick={changeSellTokenInput} style={{ marginLeft: 5 }}>
                                                    Cancel
                                                </Button>
                                            </div>
                                        </>
                                    ) : (
                                        props.sell && (
                                            <Button color="primary" onClick={changeSellTokenInput}>
                                                SELL NOW
                                            </Button>
                                        )
                                    )}
                                    {props.buy && (
                                        <Button color="primary" onClick={buyToken}>
                                            BUY NOW
                                        </Button>
                                    )}
                                    {props.closeForSale && (
                                        <Button color="primary" onClick={closeForSaleToken}>
                                            CLOSE FOR SALE
                                        </Button>
                                    )}
                                </>
                            ) : (
                                <Button color="primary" onClick={connectWallet}>
                                    Connect
                                </Button>
                            )}
                            <Link className="card-menu-item" to={`/nft/${data.token_id}`}>
                                View collectible
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default TradingCard
